// src/components/block/userManagment/ViewerCreditsJournal.tsx
//
// Fiche d'un spectateur : ses crédits Kleon et les vidéos et directs qu'il a regardés (superadmin).

import React, { useEffect, useState } from 'react';
import axios from 'axios';

import { API_URLS } from '../../../backendServices/urls';
import { useTypedSelector } from '../../../store/useTypeSelector';
import { RootState } from '../../../store/generalReducer';

interface Session {
  kind           : 'video' | 'channel';
  title          : string | null;
  startDate      : string;
  watchedSeconds : number | null;
  countedSeconds : number | null;
  credits        : number;
}

const cell: React.CSSProperties = { padding: '6px 8px', textAlign: 'left' };
const number: React.CSSProperties = { ...cell, textAlign: 'right', fontVariantNumeric: 'tabular-nums' };

const minutes = (seconds: number | null) => seconds === null ? '—' : `${Math.round(seconds / 60)} min`;

export const ViewerCreditsJournal: React.FC<{ userId: number }> = ({ userId }) => {
  const { authentication } = useTypedSelector((state: RootState) => state.authenticationReducer);
  const adminId = authentication.admin?.id;

  const [ data , setData  ] = useState<{ balance: number; sessions: Session[] } | null>(null);
  const [ error, setError ] = useState(false);

  useEffect(() => {
    if (!adminId) return;
    let cancelled = false;
    axios.get(API_URLS.getViewerCreditsJournal, { params: { adminId, userId } })
      .then(({ data }) => { if (!cancelled) setData(data); })
      .catch(() => { if (!cancelled) setError(true); });
    return () => { cancelled = true; };
  }, [adminId, userId]);

  return (
    <div style={{ marginTop: 16 }}>
      <h3 style={{ margin: '0 0 8px', fontSize: 16 }}>
        Visionnages et crédits Kleon{data ? ` : ${data.balance.toLocaleString('fr-FR')} crédits` : ''}
      </h3>
      {error && <p>Journal indisponible.</p>}
      {data && data.sessions.length === 0 && <p>Aucun visionnage.</p>}
      {data && data.sessions.length > 0 && (
        <div style={{ maxHeight: 320, overflow: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <thead>
              <tr>
                <th style={cell}>Date</th>
                <th style={cell}>Contenu</th>
                <th style={number}>Regardé</th>
                <th style={number}>Crédits</th>
              </tr>
            </thead>
            <tbody>
              {data.sessions.map((session, index) => (
                <tr key={index}>
                  <td style={{ ...cell, whiteSpace: 'nowrap' }}>{session.startDate}</td>
                  <td style={cell}>{session.kind === 'channel' ? `Direct : ${session.title || 'chaîne supprimée'}` : (session.title || 'Vidéo supprimée')}</td>
                  <td style={number}>{minutes(session.watchedSeconds)}</td>
                  <td style={number}>{session.credits}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ViewerCreditsJournal;
